var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-button-block" }, [
    _c(
      "a",
      {
        staticClass: "cms-button-block__btn",
        class: [
          "cms-button-block__btn--" + _vm.size,
          "cms-button-block__btn--" + _vm.resolvedVariant,
          { "cms-button-block__btn--full": _vm.isFullWidth },
        ],
        style: _vm.customStyle,
        attrs: { href: _vm.url || "#" },
      },
      [
        _vm.icon
          ? _c("i", {
              staticClass: "cms-button-block__icon",
              class: "fa fa-" + _vm.icon,
            })
          : _vm._e(),
        _vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t"),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }